'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

function findResponder(message, responders) {
  var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);
  var senderType = (0, _commonMessageFormatGetters.getSenderType)(message) || _senderTypes.AGENT;

  return responders ? responders.getIn([senderType, '' + senderId]) : undefined;
}

exports.default = findResponder;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/utils/findResponder.js
// module id = 1147
// module chunks = 2 3